import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import CarForm from '../Cars/CarForm';
import BookingForm from '../Booking/BookingForm';
import { addCar } from '../../actions/carActions';
import { Button } from '../utils/forms/Button';
import { find } from 'lodash';
import MainPage from './MainPage';
import { getUserPlaces } from '../../actions/parkingSpotActions';

export default function BookingPage() {
  const cars = useSelector((state) => state.cars);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.id);
  const userPlace = useSelector((state) =>
    find(state.spots, (spot) => spot.userId === userId)
  );

  async function handleSubmit(values) {
    const car = {
      name: values.carBrand,
      primary: values.favourite,
      plateNo: values.carPlate
    };
    try {
      await dispatch(addCar(car));
      toast.success(
        `Přidali jste si auto a můžete si udělat svoji první rezervaci`
      );
    } catch (err) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error('Ups! Něco se nepovedlo, napište nám');
      }
    }
  }

  if (isEmpty(cars)) {
    return (
      <div className="pl3 pr3">
        <div className="h4 center">
          Zatím nemáte přidaná žádná auta,
          <br />
          aby jste mohli dělat rezervace jedno přidejte.
        </div>
        <CarForm
          handleSubmit={handleSubmit}
          initialValues={{ carPlate: '', carBrand: '', favourite: true }}
        />
      </div>
    );
  }

  if (!isEmpty(userPlace)) {
    return <MainPage />;
  }

  return <BookingForm />;
}
